// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"styles_modalOverlay__1T_Iq","modalContent":"styles_modalContent__1xsub","modalBtnClose":"styles_modalBtnClose__15GkM","opener":"styles_opener__PsKEd"};